import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import Hr from '../../../../components/Hr';
import ReactHtmlParser from 'html-react-parser';

const AdditionalInfo = (props) => {
  const { product } = props;

  return (
    <Container>
      <Box
        sx={{
          my: 4,
        }}>
        <Typography variant="h2" mb={3}>
          Additional Info
        </Typography>

        <Box>{product && ReactHtmlParser(product.additional_info + '')}</Box>
      </Box>
      <Hr />
    </Container>
  );
};

export default AdditionalInfo;
